import { Tooltip } from '@festina-life/ui/feedback'
import type { ComponentProps } from 'react'

import { useLayoutContext } from '../../context/layoutContext'

export const TemplateDocumentationTooltip = (
  props: ComponentProps<typeof Tooltip>,
) => {
  const {
    preferences: {
      common: { isShowingDocumentationOnHover },
    },
  } = useLayoutContext()

  return isShowingDocumentationOnHover ? (
    <Tooltip {...props} tip={props.tip}>
      {props.children}
    </Tooltip>
  ) : (
    props.children
  )
}
